module.exports = __webpack_public_path__ + "static/media/SZ.98b9c93b.png";